/**
 * Transition Rules: EnergyPlus 24.2 to 25.1
 *
 * Based on the official EnergyPlus transition rules from CreateNewIDFUsingRulesV25_1_0.f90
 *
 * This transition has no object schema changes - only the version number is updated.
 * Report variable mappings may exist in the CSV file.
 */

import type { VersionTransition, ObjectTransitionRule } from '../types';

/**
 * Create the transition definition for 24.2 to 25.1
 */
export function createTransition_24_2_to_25_1(): VersionTransition {
  const objectRules = new Map<string, ObjectTransitionRule>();
  const variableMappings = new Map<string, string>();
  const deletedObjects = new Set<string>();
  const renamedObjects = new Map<string, string>();

  // No object schema changes in this transition
  // Only version number update and potential report variable renames

  return {
    fromVersion: { major: 24, minor: 2 },
    toVersion: { major: 25, minor: 1 },
    objectRules,
    variableMappings,
    deletedObjects,
    renamedObjects,
  };
}
